export default "__VITE_ASSET__9OxkENbt__"